import { useApi } from "@lending/lib/api";

const noop = () => Promise.resolve();

interface Props {
  onSuccess?: () => void | Promise<void>;
  onError: (error: Record<string, string[]>) => void;
}

function useEvaluateCreditCardApplicationQuery({ onSuccess = noop, onError }: Props) {
  const $api = useApi();

  return $api.useMutation("post", "/v2/lending/credit_card_applications/{uuid}/evaluate/", {
    onSuccess,
    onError,
  });
}

export { useEvaluateCreditCardApplicationQuery };
